import React, { Component } from 'react'
import './style.css'
import { connect } from 'react-redux'
import Card from '../components/card/card'
import NavBar from '../components/navBar/navBar'
import { HideCard, ShowCard } from '../../src/actions'


class HomePage extends Component {

   constructor(props) {
       super(props)
       this.state = {
       }
       this.windowHeight = window.innerHeight > 600 ? window.innerHeight : 600
       document.title = 'JustLegal | Home'
    }

    scrollTo = (ref) => {
        ref.scrollIntoView({ behavior: 'smooth' })
    }

    relocationTitle = () => {
        switch(this.props.language) {
            default:
                return 'Relocation Assistance'
        }
    }

    adminTitle = () => {
        switch(this.props.language) {
            default:
                return 'Administrative Support & Consultation'
        }
    }

    leaseTitle = () => {
        switch(this.props.language) {                
            default:
                return 'Lease Agreement Review'
        }
    }

    relocationText = () => {
        switch(this.props.language) {
            default:
                return 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
        }
    }

    adminText = () => {
        switch(this.props.language) {
            default:
                return 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
        }
    }

    leaseText = () => {
        switch(this.props.language) {
            default:
                return 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
        }
    }

    render() {
        return(
            <div className={'page page-homePage ' + (this.props.cardView ? 'noscroll' : '')}>

            <div className={'intro-homePage'} style={{minHeight:this.windowHeight}}>
                <div className={'buttonContainer-homePage'}>
                    <button className={'button-homePage'}
                    onClick={() => this.scrollTo(this.reloRef)}>
                        {this.relocationTitle()}
                    </button>
                    <button className={'button-homePage'}
                    onClick={() => this.scrollTo(this.adminRef)}>
                        {this.adminTitle()}
                    </button>
                    <button className={'button-homePage'}
                    onClick={() => this.scrollTo(this.leaseRef)}>
                        {this.leaseTitle()}
                    </button>
                </div>

                <h1 className={'introTitle-homePage'}>Here at <span className={'logo-homePage'}>Just legal</span> we help you get off your feet.</h1>
                
            </div>

            <div className={'content-homePage'} style={{minHeight:this.windowHeight}}
            ref={(ref) => this.reloRef=ref}>
                <h1 className={'contentTitle-homePage'}>{this.relocationTitle()}</h1>

                <div className={'text-homePage'}>
                    {this.relocationText()}
                </div>
            </div>

            <div className={'content-homePage'} style={{minHeight:this.windowHeight}}
            ref={(ref) => this.adminRef=ref}>
                <h1 className={'contentTitle-homePage'}>{this.adminTitle()}</h1>

                <div className={'text-homePage'}>
                    {this.adminText()}
                </div>
            </div>

            <div className={'content-homePage'} style={{minHeight:this.windowHeight}}
            ref={(ref) => this.leaseRef=ref}>
                <h1 className={'contentTitle-homePage'}>{this.leaseTitle()}</h1>

                <div className={'text-homePage'}>
                    {this.leaseText()}
                </div>

            </div>

              
                <NavBar language={this.props.language} page={'home'}
                showCard={() => this.props.dispatch(ShowCard())}/>
            
                <Card cardView={this.props.cardView} language={this.props.language} 
                hideCard={() => this.props.dispatch(HideCard())}/>
            </div>
        )
    }
}

const mapStateToProps = (state) =>({
    language: state.language,
    cardView: state.cardView,
})
export default connect(mapStateToProps)(HomePage)


// WEBPACK FOOTER //
// ./src/ui/homePage/homePage.js